import { render, staticRenderFns } from "./ShopSet.vue?vue&type=template&id=32e3f09c&"
import script from "./ShopSet.vue?vue&type=script&lang=js&"
export * from "./ShopSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports